import React, { useState } from "react";
import { MdAdd } from "react-icons/md";
import ManualOrderForm from "./components/ManualOrderForm";

const ManualOrder = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
      <div className="col-span-full">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">
            Manual Orders
          </h2>
          <button
            onClick={() => setShowForm(true)}
            className="flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-white hover:bg-primary/90"
          >
            <MdAdd className="h-5 w-5" />
            <span>Create Order</span>
          </button>
        </div>
      </div>

      {showForm && (
        <div className="col-span-full">
          <ManualOrderForm onClose={() => setShowForm(false)} />
        </div>
      )}
    </div>
  );
};

export default ManualOrder;
